import { render } from "./SearchHistory.vue?vue&type=template&id=13b9c614"
import script from "./SearchHistory.vue?vue&type=script&lang=js"
export * from "./SearchHistory.vue?vue&type=script&lang=js"
script.render = render

export default script